import { Typography } from '@mui/material';
import { FC } from 'react';

import BottomContent from './BottomContent/BottomContent';
import Buttons from './Buttons';
import styles from './MethodReceiving.module.sass';
import Switches from './Switches';
import { useMethodReceiving } from './useMethodReceiving';

const MethodReceiving: FC = () => {
  const { method, actions } = useMethodReceiving();
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Typography variant="h5" fontWeight={700}>
          Способ получения
        </Typography>
        <Switches
          toggleSwitch={actions.toggleSwitch}
          setTab={actions.setTab}
          tab={method.tab}
        />
      </div>
      <Buttons
        handleActiveCity={actions.handleActiveCity}
        activeCity={method.activeCity}
        tab={method.tab}
      />
      <BottomContent activeCity={method.activeCity} tab={method.tab} />
    </div>
  );
};

export default MethodReceiving;
